import React, { useEffect, useState } from 'react';
import styles from './PlayerThumbnail.module.scss';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

const PlayerThumbnail = ({ active, url, parentNode, className, isDraft, showError, currentZoomStyles = {} }) => {
  const [heightScaled, setHeightScaled] = useState(false);

  const { t } = useTranslation();

  useEffect(() => {
    if (url && parentNode) {
      const img = new Image();
      img.onload = () => {
        const imgScale = img.width / img.height;
        const defaultPlayerScale = 16 / 9;

        const playerScale = parentNode?.offsetWidth
          ? parentNode?.offsetWidth / parentNode?.offsetHeight
          : defaultPlayerScale;

        setHeightScaled(imgScale < playerScale);
      };
      img.src = url;
    }
  }, [url, parentNode, active]);

  return (
    <div className={cx(styles.container, className)}>
      {/**
       * This additional wrapper is required so that if there is a zoom for a horizontal scene,
       * the scene will be zoomed in while maintaining the aspect ratio and original size
       * This is required because the backend processes the zoom for the scene in exactly the same way,
       * as well as to save the existing logic of working with the scene (for example, transition position, textPanel, etc.)
       */}
      <div className={styles.thumbnailWrapper}>
        {isDraft || showError ? null : (
          <img
            src={url}
            alt={t('accessibility.play_video')}
            tabIndex={0}
            className={cx(styles.thumbnail, { [styles.heightScaled]: heightScaled })}
            style={currentZoomStyles}
          />
        )}
      </div>
    </div>
  );
};

export default PlayerThumbnail;
